export const FIND_DEVICE = 'findDevice';
export const CLEAN_DEVICE = 'cleanDevice';
export const UPDATE_SETTINGS = 'updateSettings';
export const RESET_DEVICE = 'resetDevice';
